import { SingleDataValue } from '.';
import { ThemedFlex } from '../../theme/ThemedFlex';

export const MarketTileBtcToOil = ({ data, bitcoinPrice, formatNumber, animate }) => {
  const numberValue = data?.s15?.oil_usd[0]?.spreadProfilePrices[0]?.ask != null && bitcoinPrice != null
    ? `${formatNumber(bitcoinPrice / data.s15.oil_usd[0].spreadProfilePrices[0].ask, 0) ?? "Loading..."} bbl`
    : '';

  return (
    <ThemedFlex
      direction="column"
      mb="12px"
      py="18px"
      px="20px"
      flex={1}
      borderRadius={3}
      className={animate ? 'gray-border-custom gray-border' : ''}
    >
      <SingleDataValue label="Oil~BTC" value={numberValue} />
    </ThemedFlex>
  );
};